// --------------------------------------------------------------------------
// #54 - LOAD MORE
// --------------------------------------------------------------------------
// Author:      Alex Baulch, Thomas Jeatt
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1.1
// --------------------------------------------------------------------------

/* global picturefill */

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function getResults(config) {
        var url = config.href;

        return $.ajax({
            method: 'GET',
            url: url
        });
    }

    function init() {
        context.on('click', '[data-binding="load-activities-button"]', function (e) {
            e.preventDefault();

            // Variables scoped to context
            var activitiesList = context.parents('.inner').find('.activity-listing__activites-list');
            var buttonLoadMore = context.parents('.inner').find('.button--load-more');
            var buttonLoadAll = context.parents('.inner').find('.button--load-all');

            /// Variables scoped to active button
            var activeButton = $(this);
            var href = activeButton.attr('href');
            var loadingText = activeButton.data('loading-text');
            var buttonText = activeButton.find('.button__text').text();

            if (!activeButton.hasClass('disabled')) {
                activeButton.addClass('disabled');
                activeButton.find('.button__text').text(loadingText);

                getResults({
                    href: href
                }).done(function (data) {
                    var $data = $(data);
                    var ajaxActivitiesListItems = $data.find('.activity-listing__activites-list .activity-listing__activity-list-item');
                    var ajaxButtonLoadMore = $data.find('.button--load-more');

                    if (ajaxActivitiesListItems.length) {
                        activitiesList.append(ajaxActivitiesListItems);
                        if (typeof window.HTMLPictureElement !== 'function') {
                            picturefill();
                        }
                    }

                    /// Check if there are more results to load otherwise remove both loading buttons
                    if (activeButton.hasClass('button--load-more') && ajaxButtonLoadMore.length) {
                        /// Update URLs
                        var ajaxLoadMoreUrl = ajaxButtonLoadMore.attr('href');
                        var ajaxLoadAllUrl = ajaxButtonLoadMore.attr('href') + '&ViewAll=true';

                        buttonLoadMore.attr('href', ajaxLoadMoreUrl);
                        buttonLoadAll.attr('href', ajaxLoadAllUrl);

                        /// Remove loading styles and text from active button
                        activeButton.removeClass('disabled').blur();
                        activeButton.find('.button__text').text(buttonText);
                    } else {
                        buttonLoadMore.remove();
                        buttonLoadAll.remove();
                    }
                });
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/activities/activities-load.js
// module id = 202
// module chunks = 0